import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Trial CTA — global consistent copy across every trial button.
 * Around every CTA button we keep ONLY two lines:
 *   Line 1 (button):  "Start Free — No Card Required"
 *   Line 2 (subtext): "14 days · One AI employee · Up to 25 tasks"
 * The value line ("No platform fees...") lives ONLY in hero/headline copy,
 * never adjacent to a button.
 */
export const TRIAL_CTA_TEXT = "Start Free — No Card Required";
export const TRIAL_CTA_SUBTEXT = "14 days · One AI employee · Up to 25 tasks";
export const TRIAL_VALUE_LINE = "No platform fees. No software bundle. Pay only for the employee you hire.";

/** Big trial button with subtext under it. */
export function TrialCTA({
  variant = "gold",              // gold | dark | ivory
  to = "/signup",
  testid = "trial-cta",
  className = "",
  fullWidth = false,
}) {
  const nav = useNavigate();
  const base =
    variant === "gold"   ? "btn-gold" :
    variant === "ivory"  ? "bg-ivory text-obsidian hover:bg-white" :
                           "bg-obsidian text-ivory hover:bg-gold hover:text-obsidian";
  return (
    <div className={`inline-flex flex-col ${fullWidth ? "w-full" : ""} ${className}`} data-testid={`${testid}-wrap`}>
      <button
        data-testid={testid}
        onClick={() => nav(to)}
        className={`${base} ${variant === "dark" || variant === "ivory" ? "px-7 py-3.5 font-semibold inline-flex items-center gap-2" : ""} ${fullWidth ? "w-full justify-center" : ""}`}
      >
        {TRIAL_CTA_TEXT} <ArrowRight size={16} />
      </button>
      <span data-testid={`${testid}-sub`} className={`text-xs mt-2 tracking-wide ${variant === "ivory" ? "text-obsidian/70" : "text-steel"}`}>
        {TRIAL_CTA_SUBTEXT}
      </span>
    </div>
  );
}

export default TrialCTA;
